import { Component, OnInit} from '@angular/core';
import { FlashService } from "../services/flash.service";

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progressBar.component.html',
    styleUrls: ['./progressBar.component.scss']
})
export class ProgressBarComponent implements OnInit {

    loader: any;

    constructor(private flashService: FlashService) {};

    ngOnInit() {
        this.loader = this.flashService.progressBar;
    }   
}

